module.exports = __webpack_public_path__ + "static/media/bip.842fade0.svg";